"use strict";

function withNaming(r) {
  var n = r.n || "",
      t = r.v || r.m;

  function i(i, e, a, o) {
    var f = e ? n + i + r.e + e : n + i,
        v = f;

    if (a) {
      var s = " " + v + r.m;

      for (var u in a) {
        if (a.hasOwnProperty(u)) {
          var c = a[u];
          !0 === c ? v += s + u : c && (v += s + u + t + c);
        }
      }
    }

    if (void 0 !== o) for (var g = 0, p = o.length; g < p; g++) {
      var h = o[g];
      if ("string" == typeof h && h) for (var m = h.split(" "), y = 0; y < m.length; y++) {
        var l = m[y];
        l !== f && (v += " " + l);
      }
    }
    return v;
  }

  return function (r, n) {
    return function (t, e, a) {
      return "string" == typeof t ? Array.isArray(e) ? i(r, t, void 0, e) : i(r, t, e, a) : i(r, n, t, e);
    };
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var cn = withNaming({
  e: "-",
  m: "_"
});
exports.cn = cn, exports.withNaming = withNaming;